import { useEffect, useState } from 'react';
import { ADVANCED_CONSENT_LOCALES } from '../services/analytics/analytics-consent.locales';
import { ANALYTICS_CONSENT_CHANGED, AnalyticsConsentService } from '../services/analytics/analytics-consent.service';
import { AnalyticsConsent } from '../services/analytics/types';
import { useLocaleDetails } from './use-locale-details';

type AnalyticsConsentState = {
    analyticsConsent: AnalyticsConsent;
    analyticsConsentRequired: boolean;
};

export function useAnalyticsConsent(): AnalyticsConsentState {
    const { localeCode } = useLocaleDetails();
    const [analyticsConsent, setAnalyticsConsent] = useState<AnalyticsConsent>(() => AnalyticsConsentService.getConsent());
    const analyticsConsentRequired = ADVANCED_CONSENT_LOCALES.includes(localeCode as (typeof ADVANCED_CONSENT_LOCALES)[number]);

    useEffect(() => {
        const updateConsent = () => setAnalyticsConsent(AnalyticsConsentService.getConsent());
        window.addEventListener(ANALYTICS_CONSENT_CHANGED, updateConsent);
        return () => window.removeEventListener(ANALYTICS_CONSENT_CHANGED, updateConsent);
    }, []);

    return { analyticsConsent, analyticsConsentRequired };
}
